// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import swal from 'sweetalert';
// import Sidebar from '../Sidebar/Sidebar';



// const User = () => {
//   const [users, setUsers] = useState([]);
//   const [username, setUsername] = useState('');
//   const [fullname, setFullname] = useState('');
//   const [password, setPassword] = useState('');
//   const [role, setRole] = useState('Admin');

//   // Fetch all users
//   useEffect(() => {
//     axios.get('https://posapi.emedha.in/api/users')
//       .then(response => {
//         setUsers(response.data);
//       })
//       .catch(error => {
//         console.error('There was an error fetching users!', error);
//       });
//   }, []);

//   // Handle user deletion
//   const handleDelete = (userId) => {
//     axios.delete(`https://posapi.emedha.in/api/users/${userId}`)
//       .then(() => {
//         swal('Info', 'User Has Been Deleted', 'info');
//         setUsers(users.filter(user => user.user_id !== userId));
//       })
//       .catch(error => {
//         console.error('There was an error deleting the user!', error);
//       });
//   };

//   // Handle user creation
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     axios.post('https://posapi.emedha.in/api/users', {
//       username,
//       fullname,
//       password,
//       role
//     })
//     .then(() => {
//       swal('Success', 'User added successfully', 'success');
//       setUsers([...users, { username, fullname, role }]);
//     })
//     .catch(error => {
//       swal('Warning', 'Username already exists', 'warning');
//       console.error('Error adding user:', error);
//     });
//   };

//   return (
//     <>
//     <Sidebar/>
//     <div id='main'>
//     <div className="container">
//       <h2>Register a New User</h2>
//       <form onSubmit={handleSubmit}>
//         <div>
//           <label>Username</label>
//           <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
//         </div>
//         <div>
//           <label>Full Name</label>
//           <input type="text" value={fullname} onChange={(e) => setFullname(e.target.value)} required />
//         </div>
//         <div>
//           <label>Password</label>
//           <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
//         </div>
//         <div>
//           <label>Role</label>
//           <select value={role} onChange={(e) => setRole(e.target.value)} required>
//             <option>Admin</option>
//             <option>Operator</option>
//           </select>
//         </div>
//         <button type="submit">Submit</button>
//       </form>

//       <h3>List of Users</h3>
//       <table>
//         <thead>
//           <tr>
//             <th>No</th>
//             <th>Username</th>
//             <th>Full Name</th>
//             <th>Role</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {users.map((user, index) => (
//             <tr key={user.user_id}>
//               <td>{index + 1}</td>
//               <td>{user.username}</td>
//               <td>{user.fullname}</td>
//               <td>{user.role}</td>
//               <td>
//                 <button onClick={() => handleDelete(user.user_id)}>Delete</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//     </div>
//     </>
//   );
// };

// export default User;




// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import swal from 'sweetalert';
// import Sidebar from '../Sidebar/Sidebar';

// const User = () => {
//     const [users, setUsers] = useState([]);
//     const [username, setUsername] = useState('');
//     const [fullname, setFullname] = useState('');
//     const [password, setPassword] = useState('');
//     const [role, setRole] = useState('Admin');

//     // Fetch all users
//     useEffect(() => {
//         axios.get('https://posapi.emedha.in/api/users')
//             .then(response => {
//                 setUsers(response.data);
//             })
//             .catch(error => {
//                 console.error('There was an error fetching users!', error);
//             });
//     }, []);

//     // Handle user deletion
//     const handleDelete = (userId) => {
//         axios.delete(`https://posapi.emedha.in/api/users/${userId}`)
//             .then(() => {
//                 swal('Info', 'User Has Been Deleted', 'info');
//                 setUsers(users.filter(user => user.user_id !== userId));
//             })
//             .catch(error => {
//                 console.error('There was an error deleting the user!', error);
//             });
//     };

//     // Handle user creation
//     const handleSubmit = (e) => {
//         e.preventDefault();

//         axios.post('https://posapi.emedha.in/api/users', {
//             username,
//             fullname,
//             password,
//             role
//         })
//             .then(() => {
//                 swal('Success', 'User added successfully', 'success');
//                 setUsers([...users, { username, fullname, role }]);
//                 setUsername('');
//                 setFullname('');
//                 setPassword('');
//                 setRole('');
//             })
//             .catch(error => {
//                 swal('Warning', 'Username already exists', 'warning');
//                 console.error('Error adding user:', error);
//             });
//     };

//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <div className="row">


//                     <div className="col-lg-10 col-md-9 col-sm-12">
//                         <div className="container mt-5">
//                             <h2>Register a New User</h2>
//                             <form onSubmit={handleSubmit}>
//                                 <div className="mb-3">
//                                     <label className="form-label">Username</label>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={username}
//                                         onChange={(e) => setUsername(e.target.value)}
//                                         required
//                                     />
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label">Full Name</label>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={fullname}
//                                         onChange={(e) => setFullname(e.target.value)}
//                                         required
//                                     />
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label">Password</label>
//                                     <input
//                                         type="password"
//                                         className="form-control"
//                                         value={password}
//                                         onChange={(e) => setPassword(e.target.value)}
//                                         required
//                                     />
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label">Role</label>
//                                     <select
//                                         className="form-select"
//                                         value={role}
//                                         onChange={(e) => setRole(e.target.value)}
//                                         required
//                                     >
//                                         <option>Admin</option>
//                                         <option>Operator</option>
//                                     </select>
//                                 </div>
//                                 <button type="submit" className="btn btn-primary">Submit</button>
//                             </form>

//                             <h3 className="mt-5">List of Users</h3>
//                             {/* <table className="table table-bordered">
//                 <thead>
//                   <tr>
//                     <th>No</th>
//                     <th>Username</th>
//                     <th>Full Name</th>
//                     <th>Role</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {users.map((user, index) => (
//                     <tr key={user.user_id}>
//                       <td>{index + 1}</td>
//                       <td>{user.username}</td>
//                       <td>{user.fullname}</td>
//                       <td>{user.role}</td>
//                       <td>
//                         <button
//                           onClick={() => handleDelete(user.user_id)}
//                           className="btn btn-danger"
//                         >
//                           Delete
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table> */}
//                             <div className="table-responsive">
//                                 <table className="table table-bordered">
//                                     <thead>
//                                         <tr>
//                                             <th>No</th>
//                                             <th>Username</th>
//                                             <th>Full Name</th>
//                                             <th>Role</th>
//                                             <th>Action</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {users.map((user, index) => (
//                                             <tr key={user.user_id}>
//                                                 <td>{index + 1}</td>
//                                                 <td>{user.username}</td>
//                                                 <td>{user.fullname}</td>
//                                                 <td>{user.role}</td>
//                                                 <td>
//                                                     <button
//                                                         onClick={() => handleDelete(user.user_id)}
//                                                         className="btn btn-danger"
//                                                     >
//                                                         Delete
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default User;


// import React, { useState, useEffect } from "react";

// // Self-contained SVG Icons
// const Icons = {
//   Plus: (size = 16) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="12" y1="5" x2="12" y2="19"></line>
//       <line x1="5" y1="12" x2="19" y2="12"></line>
//     </svg>
//   ),
//   Search: (size = 16) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <circle cx="11" cy="11" r="8"></circle>
//       <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//     </svg>
//   ),
//   Edit2: (size = 14) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
//     </svg>
//   ),
//   Trash2: (size = 14) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="3 6 5 6 21 6"></polyline>
//       <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
//       <line x1="10" y1="11" x2="10" y2="17"></line>
//       <line x1="14" y1="11" x2="14" y2="17"></line>
//     </svg>
//   )
// };

// export default function UsersScreen() {
//   const [users, setUsers] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Form states for exact 4 inputs
//   const [username, setUsername] = useState("");
//   const [fullName, setFullName] = useState("");
//   const [password, setPassword] = useState("");
//   const [role, setRole] = useState("Admin");
//   const [editingId, setEditingId] = useState(null);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   // Responsive state
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // API Endpoint URL
//   const API_URL = "https://pos.emedha.in/users";

//   // 1. READ / FETCH Users on component mount
//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ table: "tbl_users", action: "get" })
//       });
//       const data = await response.json();

//       if (data && data.rows) {
//         const formatted = data.rows.map((row, index) => ({
//           id: row.user_id || index + 1,
//           username: row.username,
//           fullName: row.full_name,
//           password: row.password || "",
//           role: row.role || "Operator"
//         }));
//         setUsers(formatted);
//       }
//     } catch (error) {
//       console.error("Failed to fetch users:", error);
//       // Fallback initial mock data if API fails
//       setUsers([
//         { id: 1, username: "admin_krishna", fullName: "Swami Krishnadas", password: "password123", role: "Admin" },
//         { id: 2, username: "operator_ravi", fullName: "Ravi Shankar", password: "password123", role: "Operator" },
//         { id: 3, username: "operator_sunitha", fullName: "Sunitha Nair", password: "password123", role: "Operator" },
//         { id: 4, username: "admin_deepak", fullName: "Deepak Rao", password: "password123", role: "Admin" },
//         { id: 5, username: "operator_anitha", fullName: "Anitha Menon", password: "password123", role: "Operator" },
//         { id: 6, username: "operator_govind", fullName: "Govind Pillai", password: "password123", role: "Operator" },
//         { id: 7, username: "operator_radha", fullName: "Radha Kumari", password: "password123", role: "Operator" }
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filtered = users.filter(
//     (u) =>
//       u.username.toLowerCase().includes(search.toLowerCase()) ||
//       u.fullName.toLowerCase().includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filtered.length / itemsPerPage) || 1;
//   const paginatedUsers = filtered.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleSearchChange = (e) => {
//     setSearch(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleOpenAddModal = () => {
//     setEditingId(null);
//     setUsername("");
//     setFullName("");
//     setPassword("");
//     setRole("Admin");
//     setShowModal(true);
//   };

//   const handleOpenEditModal = (u) => {
//     setEditingId(u.id);
//     setUsername(u.username);
//     setFullName(u.fullName);
//     setPassword(u.password);
//     setRole(u.role);
//     setShowModal(true);
//   };

//   // 2. CREATE & UPDATE User with API Integration
//   const handleSaveUser = async () => {
//     if (!username.trim() || !fullName.trim() || !password.trim()) {
//       alert("All fields are required");
//       return;
//     }

//     const payloadId = editingId !== null ? editingId : Date.now();

//     const payload = {
//       table: "tbl_users",
//       rows: [
//         {
//           user_id: payloadId,
//           username,
//           full_name: fullName,
//           password,
//           role
//         }
//       ]
//     };

//     try {
//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       if (response.ok) {
//         if (editingId !== null) {
//           setUsers(
//             users.map((u) =>
//               u.id === editingId ? { ...u, username, fullName, password, role } : u
//             )
//           );
//         } else {
//           const newUser = {
//             id: payloadId,
//             username,
//             fullName,
//             password,
//             role
//           };
//           setUsers([newUser, ...users]);
//         }
//       }
//     } catch (error) {
//       console.error("Failed to save user:", error);
//     }

//     setShowModal(false);
//     setUsername("");
//     setFullName("");
//     setPassword("");
//     setRole("Admin");
//     setEditingId(null);
//   };

//   // 3. DELETE User with API Integration
//   const handleDeleteUser = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this user?")) return;

//     const payload = {
//       table: "tbl_users",
//       action: "delete",
//       user_id: id
//     };

//     try {
//       await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       setUsers(users.filter((u) => u.id !== id));
//       if (paginatedUsers.length === 1 && currentPage > 1) {
//         setCurrentPage(currentPage - 1);
//       }
//     } catch (error) {
//       console.error("Failed to delete user:", error);
//     }
//   };

//   // 4. Smart Pagination Calculation
//   const getPaginationItems = () => {
//     if (totalPages <= 8) {
//       return Array.from({ length: totalPages }, (_, i) => i + 1);
//     }
//     if (currentPage <= 4) {
//       return [1, 2, 3, 4, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
//     }
//     if (currentPage >= totalPages - 3) {
//       return [1, 2, 3, 4, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
//     }
//     return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         gap: "20px",
//         width: "100%",
//         maxWidth: "1280px",
//         margin: "0 auto",
//         padding: isMobile ? "16px" : "24px 32px",
//         boxSizing: "border-box",
//         fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
//       }}
//     >
//       {/* Header */}
//       <div
//         style={{
//           display: "flex",
//           flexDirection: isMobile ? "column" : "row",
//           alignItems: isMobile ? "flex-start" : "center",
//           justifyContent: "space-between",
//           gap: "16px",
//           width: "100%"
//         }}
//       >
//         <div>
//           <h2
//             style={{
//               margin: 0,
//               fontSize: isMobile ? "22px" : "26px",
//               fontWeight: "700",
//               color: "#111827",
//               fontFamily: "'Cinzel', serif"
//             }}
//           >
//             Users
//           </h2>
//           <p style={{ margin: "4px 0 0 0", fontSize: "14px", color: "#6b7280" }}>
//             {users.length} total users configured
//           </p>
//         </div>

//         <button
//           onClick={handleOpenAddModal}
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "8px",
//             padding: "10px 20px",
//             borderRadius: "12px",
//             fontSize: "14px",
//             fontWeight: "600",
//             color: "#ffffff",
//             background: "linear-gradient(135deg, #f97316, #c2410c)",
//             boxShadow: "0 4px 16px rgba(249, 115, 22, 0.3)",
//             border: "none",
//             cursor: "pointer",
//             width: isMobile ? "100%" : "auto"
//           }}
//         >
//           {Icons.Plus(16)}
//           <span>Add User</span>
//         </button>
//       </div>

//       {/* Search Toolbar */}
//       <div style={{ display: "flex", width: "100%" }}>
//         <div style={{ position: "relative", flex: 1, maxWidth: isMobile ? "100%" : "420px" }}>
//           <span
//             style={{
//               position: "absolute",
//               left: "14px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               color: "#9ca3af",
//               display: "flex",
//               alignItems: "center"
//             }}
//           >
//             {Icons.Search(16)}
//           </span>
//           <input
//             placeholder="Search users…"
//             value={search}
//             onChange={handleSearchChange}
//             style={{
//               width: "100%",
//               padding: "11px 16px 11px 40px",
//               borderRadius: "12px",
//               border: "1px solid #e5e7eb",
//               fontSize: "14px",
//               outline: "none",
//               backgroundColor: "#fdf8f3",
//               color: "#1f2937",
//               boxSizing: "border-box"
//             }}
//           />
//         </div>
//       </div>

//       {/* Main Content / Table */}
//       {loading ? (
//         <div style={{ textAlign: "center", padding: "50px 0", color: "#6b7280", fontSize: "14px" }}>
//           Loading users...
//         </div>
//       ) : (
//         <>
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "16px",
//               border: "1px solid #ffedd5",
//               boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//               width: "100%",
//               overflow: "hidden"
//             }}
//           >
//             <div style={{ width: "100%", overflowX: "auto" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   minWidth: "650px",
//                   borderCollapse: "collapse",
//                   textAlign: "left"
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       backgroundColor: "rgba(255, 247, 237, 0.6)",
//                       borderBottom: "1px solid #ffedd5",
//                       fontSize: "12px",
//                       fontWeight: "600",
//                       color: "#374151",
//                       textTransform: "uppercase",
//                       letterSpacing: "0.05em"
//                     }}
//                   >
//                     <th style={{ padding: "14px 20px", width: "70px" }}>S.No</th>
//                     <th style={{ padding: "14px 20px" }}>Username</th>
//                     <th style={{ padding: "14px 20px" }}>Full Name</th>
//                     <th style={{ padding: "14px 20px", width: "130px" }}>Role</th>
//                     <th style={{ padding: "14px 20px", textAlign: "right", width: "110px" }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody style={{ fontSize: "14px" }}>
//                   {paginatedUsers.length > 0 ? (
//                     paginatedUsers.map((user, index) => {
//                       const serialNumber = (currentPage - 1) * itemsPerPage + index + 1;
//                       const isAdmin = user.role === "Admin";
//                       return (
//                         <tr
//                           key={user.id}
//                           style={{
//                             borderBottom: "1px solid #fff7ed",
//                             backgroundColor: "#ffffff"
//                           }}
//                         >
//                           <td style={{ padding: "16px 20px", color: "#6b7280", fontWeight: "500" }}>
//                             {serialNumber}
//                           </td>
//                           <td style={{ padding: "16px 20px", fontWeight: "600", color: "#111827" }}>
//                             {user.username}
//                           </td>
//                           <td style={{ padding: "16px 20px", color: "#4b5563" }}>
//                             {user.fullName}
//                           </td>
//                           <td style={{ padding: "16px 20px" }}>
//                             <span
//                               style={{
//                                 display: "inline-block",
//                                 fontSize: "12px",
//                                 fontWeight: "600",
//                                 padding: "4px 10px",
//                                 borderRadius: "9999px",
//                                 backgroundColor: isAdmin ? "#fef3c7" : "#dbeafe",
//                                 color: isAdmin ? "#92400e" : "#1e40af"
//                               }}
//                             >
//                               {user.role}
//                             </span>
//                           </td>
//                           <td style={{ padding: "16px 20px", textAlign: "right" }}>
//                             <div style={{ display: "inline-flex", gap: "8px", justifyContent: "flex-end" }}>
//                               <button
//                                 onClick={() => handleOpenEditModal(user)}
//                                 title="Edit User"
//                                 style={{
//                                   width: "34px",
//                                   height: "34px",
//                                   borderRadius: "8px",
//                                   backgroundColor: "#fff7ed",
//                                   color: "#ea580c",
//                                   border: "none",
//                                   cursor: "pointer",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center"
//                                 }}
//                               >
//                                 {Icons.Edit2(14)}
//                               </button>
//                               <button
//                                 onClick={() => handleDeleteUser(user.id)}
//                                 title="Delete User"
//                                 style={{
//                                   width: "34px",
//                                   height: "34px",
//                                   borderRadius: "8px",
//                                   backgroundColor: "#fef2f2",
//                                   color: "#ef4444",
//                                   border: "none",
//                                   cursor: "pointer",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center"
//                                 }}
//                               >
//                                 {Icons.Trash2(14)}
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={5}
//                         style={{
//                           textAlign: "center",
//                           padding: "36px 0",
//                           color: "#9ca3af",
//                           fontSize: "14px"
//                         }}
//                       >
//                         No users found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Full Smart Pagination Controls */}
//           {totalPages > 1 && (
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: isMobile ? "column" : "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "12px",
//                 paddingTop: "8px",
//                 width: "100%",
//                 flexWrap: "wrap"
//               }}
//             >
//               <p style={{ margin: 0, fontSize: "13px", color: "#6b7280" }}>
//                 Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
//                 {Math.min(currentPage * itemsPerPage, filtered.length)} of {filtered.length} users
//               </p>

//               <div style={{ display: "flex", alignItems: "center", gap: "4px", flexWrap: "wrap" }}>
//                 {/* First Page */}
//                 <button
//                   onClick={() => setCurrentPage(1)}
//                   disabled={currentPage === 1}
//                   style={{
//                     padding: "6px 10px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     opacity: currentPage === 1 ? 0.4 : 1
//                   }}
//                 >
//                   « First
//                 </button>

//                 {/* Previous */}
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                   disabled={currentPage === 1}
//                   style={{
//                     padding: "6px 12px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     opacity: currentPage === 1 ? 0.4 : 1
//                   }}
//                 >
//                   Prev
//                 </button>

//                 {/* Page Numbers & Ellipsis */}
//                 {getPaginationItems().map((item, index) => {
//                   if (item === "...") {
//                     return (
//                       <span
//                         key={`ellipsis-${index}`}
//                         style={{
//                           display: "inline-flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           width: "28px",
//                           height: "32px",
//                           fontSize: "14px",
//                           color: "#9ca3af",
//                           userSelect: "none"
//                         }}
//                       >
//                         ...
//                       </span>
//                     );
//                   }

//                   const isCurrent = currentPage === item;
//                   return (
//                     <button
//                       key={`page-${item}`}
//                       onClick={() => setCurrentPage(item)}
//                       style={{
//                         minWidth: "32px",
//                         height: "32px",
//                         padding: "0 6px",
//                         borderRadius: "8px",
//                         fontSize: "12px",
//                         fontWeight: isCurrent ? "700" : "500",
//                         cursor: "pointer",
//                         border: isCurrent ? "none" : "1px solid #e5e7eb",
//                         backgroundColor: isCurrent ? "#f97316" : "#ffffff",
//                         color: isCurrent ? "#ffffff" : "#4b5563",
//                         boxShadow: isCurrent ? "0 2px 8px rgba(249, 115, 22, 0.3)" : "none"
//                       }}
//                     >
//                       {item}
//                     </button>
//                   );
//                 })}

//                 {/* Next */}
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//                   disabled={currentPage === totalPages}
//                   style={{
//                     padding: "6px 12px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === totalPages ? "not-allowed" : "pointer",
//                     opacity: currentPage === totalPages ? 0.4 : 1
//                   }}
//                 >
//                   Next
//                 </button>

//                 {/* Last Page */}
//                 <button
//                   onClick={() => setCurrentPage(totalPages)}
//                   disabled={currentPage === totalPages}
//                   style={{
//                     padding: "6px 10px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === totalPages ? "not-allowed" : "pointer",
//                     opacity: currentPage === totalPages ? 0.4 : 1
//                   }}
//                 >
//                   Last »
//                 </button>
//               </div>
//             </div>
//           )}
//         </>
//       )}

//       {/* Add / Edit Modal with exact 4 inputs */}
//       {showModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             zIndex: 9999,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: "16px",
//             backgroundColor: "rgba(0,0,0,0.45)",
//             backdropFilter: "blur(2px)"
//           }}
//           onClick={() => setShowModal(false)}
//         >
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "16px",
//               padding: "24px",
//               width: "100%",
//               maxWidth: "440px",
//               boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
//               boxSizing: "border-box"
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <h3
//               style={{
//                 margin: "0 0 16px 0",
//                 fontSize: "18px",
//                 fontWeight: "700",
//                 color: "#111827",
//                 fontFamily: "'Cinzel', serif"
//               }}
//             >
//               {editingId !== null ? "Edit User" : "Add User"}
//             </h3>
//             <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     marginBottom: "6px"
//                   }}
//                 >
//                   Username
//                 </label>
//                 <input
//                   value={username}
//                   onChange={(e) => setUsername(e.target.value)}
//                   placeholder="e.g. admin_krishna"
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "14px",
//                     outline: "none",
//                     backgroundColor: "#fdf8f3",
//                     color: "#1f2937",
//                     boxSizing: "border-box"
//                   }}
//                 />
//               </div>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     marginBottom: "6px"
//                   }}
//                 >
//                   Full Name
//                 </label>
//                 <input
//                   value={fullName}
//                   onChange={(e) => setFullName(e.target.value)}
//                   placeholder="e.g. Ravi Shankar"
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "14px",
//                     outline: "none",
//                     backgroundColor: "#fdf8f3",
//                     color: "#1f2937",
//                     boxSizing: "border-box"
//                   }}
//                 />
//               </div>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     marginBottom: "6px"
//                   }}
//                 >
//                   Password
//                 </label>
//                 <input
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="••••••••"
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "14px",
//                     outline: "none",
//                     backgroundColor: "#fdf8f3",
//                     color: "#1f2937",
//                     boxSizing: "border-box"
//                   }}
//                 />
//               </div>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     marginBottom: "6px"
//                   }}
//                 >
//                   Role
//                 </label>
//                 <select
//                   value={role}
//                   onChange={(e) => setRole(e.target.value)}
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "14px",
//                     outline: "none",
//                     backgroundColor: "#fdf8f3",
//                     color: "#1f2937",
//                     boxSizing: "border-box",
//                     cursor: "pointer"
//                   }}
//                 >
//                   <option value="Admin">Admin</option>
//                   <option value="Operator">Operator</option>
//                 </select>
//               </div>
//             </div>
//             <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
//               <button
//                 type="button"
//                 onClick={() => setShowModal(false)}
//                 style={{
//                   flex: 1,
//                   padding: "10px 16px",
//                   borderRadius: "10px",
//                   border: "1px solid #e5e7eb",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   color: "#4b5563",
//                   backgroundColor: "#ffffff",
//                   cursor: "pointer"
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={handleSaveUser}
//                 style={{
//                   flex: 1,
//                   padding: "10px 16px",
//                   borderRadius: "10px",
//                   border: "none",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: "#ffffff",
//                   background: "linear-gradient(135deg, #f97316, #c2410c)",
//                   cursor: "pointer"
//                 }}
//               >
//                 {editingId !== null ? "Update User" : "Save User"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import Sidebar from '../Sidebar/Sidebar';

// Self-contained SVG Icons
const Icons = {
  Plus: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Search: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  Trash2: (size = 14) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  )
};

const User = () => {
  const [users, setUsers] = useState([]);
  const [username, setUsername] = useState('');
  const [fullname, setFullname] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('Admin');
  
  // UI & Pagination States
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch all users
  const fetchUsers = () => {
    setLoading(true);
    axios.get('https://posapi.emedha.in/api/users')
      .then(response => {
        setUsers(response.data || []);
      })
      .catch(error => {
        console.error('There was an error fetching users!', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Handle user deletion
  const handleDelete = (userId) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this user!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios.delete(`https://posapi.emedha.in/api/users/${userId}`)
          .then(() => {
            swal('Info', 'User Has Been Deleted', 'info');
            setUsers(users.filter(user => user.user_id !== userId));
            if (currentUsers.length === 1 && currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          })
          .catch(error => {
            console.error('There was an error deleting the user!', error);
          });
      }
    });
  };

  // Handle user creation
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!username.trim() || !fullname.trim() || !password.trim() || !role) {
      swal('Warning', 'Please fill all required fields', 'warning');
      return;
    }

    axios.post('https://posapi.emedha.in/api/users', {
      username,
      fullname,
      password,
      role
    })
      .then(() => {
        swal('Success', 'User added successfully', 'success');
        fetchUsers();
        setUsername('');
        setFullname('');
        setPassword('');
        setRole('Admin');
        setShowModal(false);
      })
      .catch(error => {
        swal('Warning', 'Username already exists', 'warning');
        console.error('Error adding user:', error);
      });
  };

  // Filter and Pagination Logic
  const filteredUsers = users.filter((u) =>
    (u.username && u.username.toLowerCase().includes(search.toLowerCase())) ||
    (u.fullname && u.fullname.toLowerCase().includes(search.toLowerCase())) ||
    (u.role && u.role.toLowerCase().includes(search.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredUsers.length / entriesPerPage) || 1;
  const currentUsers = filteredUsers.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  const getPaginationItems = () => {
    if (totalPages <= 8) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 4) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    if (currentPage >= totalPages - 3) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
  };

  return (
    <div 
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
        // id="main"
        // style={{
        //   flex: 1,
        //   display: 'flex',
        //   flexDirection: 'column',
        //   minWidth: 0,
        //   fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        // }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header Bar */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                Users
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                {users.length} total users configured
              </p>
            </div>

            <button
              onClick={() => setShowModal(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '10px 20px',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#ffffff',
                background: 'linear-gradient(135deg, #f97316, #c2410c)',
                boxShadow: '0 4px 16px rgba(249, 115, 22, 0.3)',
                border: 'none',
                cursor: 'pointer',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              {Icons.Plus(16)}
              <span>Add User</span>
            </button>
          </div>

          {/* Controls Bar */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              justifyContent: 'space-between',
              alignItems: isMobile ? 'stretch' : 'center',
              gap: '12px',
              width: '100%'
            }}
          >
            {/* Search Input */}
            <div style={{ position: 'relative', flex: 1, maxWidth: isMobile ? '100%' : '420px' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {Icons.Search(16)}
              </span>
              <input
                type="search"
                placeholder="Search users…"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                style={{
                  width: '100%',
                  padding: '11px 16px 11px 40px',
                  borderRadius: '12px',
                  border: '1px solid #e5e7eb',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#fdf8f3',
                  color: '#1f2937',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            {/* Entries Dropdown */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#4b5563' }}>
              <span>Show</span>
              <select
                value={entriesPerPage}
                onChange={(e) => {
                  setEntriesPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{
                  padding: '8px 12px',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  fontSize: '14px',
                  backgroundColor: '#ffffff',
                  color: '#1f2937',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <span>entries</span>
            </div>
          </div>

          {/* Table Container */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280', fontSize: '14px' }}>
              Loading users...
            </div>
          ) : (
            <>
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #ffedd5',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                  width: '100%',
                  overflow: 'hidden'
                }}
              >
                <div style={{ width: '100%', overflowX: 'auto' }}>
                  <table
                    style={{
                      width: '100%',
                      minWidth: '650px',
                      borderCollapse: 'collapse',
                      textAlign: 'left'
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: 'rgba(255, 247, 237, 0.6)',
                          borderBottom: '1px solid #ffedd5',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#374151',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em'
                        }}
                      >
                        <th style={{ padding: '14px 20px', width: '70px' }}>No</th>
                        <th style={{ padding: '14px 20px' }}>Username</th>
                        <th style={{ padding: '14px 20px' }}>Full Name</th>
                        <th style={{ padding: '14px 20px', width: '130px' }}>Role</th>
                        <th style={{ padding: '14px 20px', textAlign: 'right', width: '110px' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: '14px' }}>
                      {currentUsers.length > 0 ? (
                        currentUsers.map((user, index) => {
                          const serialNumber = (currentPage - 1) * entriesPerPage + index + 1;
                          const isAdmin = user.role === 'Admin';
                          return (
                            <tr
                              key={user.user_id || index}
                              style={{
                                borderBottom: '1px solid #fff7ed',
                                backgroundColor: '#ffffff'
                              }}
                            >
                              <td style={{ padding: '16px 20px', color: '#6b7280', fontWeight: '500' }}>
                                {serialNumber}
                              </td>
                              <td style={{ padding: '16px 20px', fontWeight: '600', color: '#111827' }}>
                                {user.username}
                              </td>
                              <td style={{ padding: '16px 20px', color: '#4b5563' }}>
                                {user.fullname}
                              </td>
                              <td style={{ padding: '16px 20px' }}>
                                <span
                                  style={{
                                    display: 'inline-block',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    padding: '4px 10px',
                                    borderRadius: '9999px',
                                    backgroundColor: isAdmin ? '#fef3c7' : '#dbeafe',
                                    color: isAdmin ? '#92400e' : '#1e40af'
                                  }}
                                >
                                  {user.role}
                                </span>
                              </td>
                              <td style={{ padding: '16px 20px', textAlign: 'right' }}>
                                <div style={{ display: 'inline-flex', gap: '8px', justifyContent: 'flex-end' }}>
                                  <button
                                    onClick={() => handleDelete(user.user_id)}
                                    title="Delete User"
                                    style={{
                                      width: '34px',
                                      height: '34px',
                                      borderRadius: '8px',
                                      backgroundColor: '#fef2f2',
                                      color: '#ef4444',
                                      border: 'none',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    {Icons.Trash2(14)}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: 'center',
                              padding: '36px 0',
                              color: '#9ca3af',
                              fontSize: '14px'
                            }}
                          >
                            No users found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Pagination Controls */}
              {totalPages > 1 && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    paddingTop: '12px',
                    width: '100%',
                    flexWrap: 'wrap'
                  }}
                >
                  <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
                    Showing {(currentPage - 1) * entriesPerPage + 1} to{' '}
                    {Math.min(currentPage * entriesPerPage, filteredUsers.length)} of {filteredUsers.length} users
                  </p>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => setCurrentPage(1)}
                      disabled={currentPage === 1}
                      title="First Page"
                      style={{
                        padding: '6px 10px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        opacity: currentPage === 1 ? 0.4 : 1
                      }}
                    >
                      « First
                    </button>

                    <button
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                      title="Previous Page"
                      style={{
                        padding: '6px 12px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        opacity: currentPage === 1 ? 0.4 : 1
                      }}
                    >
                      Prev
                    </button>

                    {getPaginationItems().map((item, index) => {
                      if (item === '...') {
                        return (
                          <span
                            key={`ellipsis-${index}`}
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '28px',
                              height: '32px',
                              fontSize: '14px',
                              color: '#9ca3af',
                              userSelect: 'none'
                            }}
                          >
                            ...
                          </span>
                        );
                      }

                      const isCurrent = currentPage === item;
                      return (
                        <button
                          key={`page-${item}`}
                          onClick={() => setCurrentPage(item)}
                          style={{
                            minWidth: '32px',
                            height: '32px',
                            padding: '0 6px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: isCurrent ? '700' : '500',
                            cursor: 'pointer',
                            border: isCurrent ? 'none' : '1px solid #e5e7eb',
                            backgroundColor: isCurrent ? '#f97316' : '#ffffff',
                            color: isCurrent ? '#ffffff' : '#4b5563',
                            boxShadow: isCurrent ? '0 2px 8px rgba(249, 115, 22, 0.3)' : 'none',
                            transition: 'all 0.15s ease'
                          }}
                        >
                          {item}
                        </button>
                      );
                    })}

                    <button
                      onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      title="Next Page"
                      style={{
                        padding: '6px 12px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        opacity: currentPage === totalPages ? 0.4 : 1
                      }}
                    >
                      Next
                    </button>

                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={currentPage === totalPages}
                      title="Last Page"
                      style={{
                        padding: '6px 10px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        opacity: currentPage === totalPages ? 0.4 : 1
                      }}
                    >
                      Last »
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Register / Add User Modal */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(2px)'
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              padding: '24px',
              width: '100%',
              maxWidth: '440px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
              boxSizing: 'border-box'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              style={{
                margin: '0 0 16px 0',
                fontSize: '18px',
                fontWeight: '700',
                color: '#111827',
                fontFamily: "'Cinzel', serif"
              }}
            >
              Register a New User
            </h3>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Username
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="e.g. admin_krishna"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Full Name
                </label>
                <input
                  type="text"
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                  placeholder="e.g. Swami Krishnadas"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Role
                </label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box',
                    cursor: 'pointer'
                  }}
                >
                  <option value="Admin">Admin</option>
                  <option value="Operator">Operator</option>
                </select>
              </div>

              <div style={{ display: 'flex', gap: '12px', marginTop: '10px' }}>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#4b5563',
                    backgroundColor: '#ffffff',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: 'none',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    background: 'linear-gradient(135deg, #f97316, #c2410c)',
                    cursor: 'pointer'
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default User;